module.exports = __webpack_public_path__ + "img/logo_rectangle.4f622800.png";